<template>
    <div>
        <!-- ALERTAS -->
        <AlertContainer :messages="msgs"/>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="isSaving">
                        {{ $t('salvar') }}
                    <svg class="svg-loader" v-if="isSaving">
                        <use :xlink:href="require('@/assets/img/icons/loader.svg')+'#layer'"></use>
                    </svg>
                </button>
            </div>
        </div>
        <div class="page page-container">
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-2">
                        <v-input
                            :id="generateId(0)"
                            ref="codigoInput"
                            v-model="venPoliticaDesconto.codigo"
                            placeholder="codigo"
                            :maxlength="50"
                            :title="'codigo'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!venPoliticaDesconto.codigo"
                            uppercase/>
                    </div>
                    <div class="column is-8">
                        <v-input
                            :id="generateId(1)"
                            ref="descricaoInput"
                            v-model="venPoliticaDesconto.descricao"
                            placeholder="descricao"
                            :maxlength="50"
                            :title="'descricao'"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!venPoliticaDesconto.descricao"
                            uppercase/>
                    </div>
                    <div class="column is-2">
                        <vss-select
                            :id="generateId(2)"
                            ref="situacao"
                            :options="situacaoSelect"
                            mlLabels
                            v-model="venPoliticaDesconto.situacao"
                            title="situacao"/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(3)"
                            ref="empresa"
                            :loading="empresasLoading"
                            :options="empresaSelect"
                            :placeholder="'selecione'"
                            v-model="venPoliticaDesconto.assEmpresaVenPoliticaDescontoList"
                            :search="carregarEmpresas"
                            @input="updateEmpresa"
                            title="empresa"
                            :closeOnSelect="false"
                            compareId
                            multiple
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(4)"
                            ref="tabpreco"
                            :title="'tabela-preco'"
                            :loading="tabPrecoLoading"
                            :options="tabPrecoSelect"
                            v-model="venPoliticaDesconto.tabelaPreco"
                            :search="carregarTabPreco"
                            @input="updateTabPreco"
                            :placeholder="'selecione'"
                            :msg="'msg-campo-obrigatorio'"
                            :required="true"
                            :invalid="!venPoliticaDesconto.tabelaPreco"
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(5)"
                            ref="colaborador"
                            :loading="colaboradorLoading"
                            :title="'colaboradores'"
                            :options="colaboradorSelect"
                            v-model="venPoliticaDesconto.assUsuarioVenPoliticaDescontoList"
                            :search="carregarColaborador"
                            @input="updateColaborador"
                            :placeholder="'selecione'"
                            :msg="'msg-campo-obrigatorio'"
                            :closeOnSelect="false"
                            compareId
                            multiple
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(6)"
                            ref="prazoPgto"
                            :loading="prazoPgtoLoading"
                            :title="'prazo-pagamento'"
                            :options="prazoPgtoSelect"
                            v-model="venPoliticaDesconto.assPrazoPagtoVenPoliticaDescontoList"
                            :search="carregarPrazoPgto"
                            @input="updatePrazoPgto"
                            :placeholder="'selecione'"
                            :closeOnSelect="false"
                            compareId
                            multiple
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(7)"
                            ref="formaPgto"
                            :title="'forma-pagamento'"
                            :options="formaPgtoSelect"
                            v-model="venPoliticaDesconto.assFormaPagtoVenPoliticaDescontoList"
                            :search="carregarFormaPgto"
                            @input="updateFormaPgto"
                            :placeholder="'selecione'"
                            :closeOnSelect="false"
                            compareId
                            multiple
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-2">
                        <verified-date-picker
                            :id="generateId(8)"
                            ref="dataInicial"
                            placeholder="selecione-uma-data"
                            v-model="venPoliticaDesconto.dataInicial"
                            :required="true"
                            :subtractDateYears="0"
                            :addDateYears="8"
                            :yearsRange="[-8,10]"
                            title="data-inicial"
                            :inForm="true"
                            :invalid="!venPoliticaDesconto.dataInicial"/>
                    </div>
                    <div class="column is-2">
                        <verified-date-picker
                            :id="generateId(9)"
                            ref="dataFinal"
                            placeholder="selecione-uma-data"
                            v-model="venPoliticaDesconto.dataFinal"
                            :required="true"
                            :subtractDateYears="0"
                            :addDateYears="8"
                            :yearsRange="[-8,10]"
                            title="data-final"
                            :inForm="true"
                            :invalid="!venPoliticaDesconto.dataFinal"/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(10)"
                            ref="cliente"
                            :title="'cliente'"
                            :options="clienteSelect"
                            :value="venPoliticaDesconto.assClienteVenPoliticaDescontoList"
                            :search="carregarCliente"
                            @input="updateCliente"
                            :placeholder="'selecione'"
                            :closeOnSelect="false"
                            compareId
                            multiple
                            searchable
                            clearable
                            noClearfix/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(11)"
                            ref="tipoOperacaoUsada"
                            :title="'tipo-operacao'"
                            :options="tipoOperacaoUsadaSelect"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!venPoliticaDesconto.tipoOperacaoUsada"
                            v-model="venPoliticaDesconto.tipoOperacaoUsada"
                            mlLabels
                            :placeholder="'selecione'"/>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            :id="generateId(12)"
                            ref="formaAplicarRegra"
                            :title="'forma-aplica-regra'"
                            :options="formaAplicarRegraSelect"
                            :required="true"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!venPoliticaDesconto.formaAplicarRegra"
                            v-model="venPoliticaDesconto.formaAplicarRegra"
                            :placeholder="'selecione'"
                            mlLabels/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AlertContainer from "@/components/shared/AlertContainer";
import Loader from "@/components/content/loader/Loader";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import RegraDescontoValidation from "@/services/validations/vendas/RegraDescontoValidation";
import Message from "@/models/Message";
import RegrasDescontoService from "@/services/RegrasDescontoService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import ColaboradorService from "@/services/ColaboradorService";
import VendasClienteService from "@/services/VendasClienteService";
import FormaPagtoService from "@/services/FormaPagtoService";
import PrazoPagtoService from "@/services/vendas/prazopagto/PrazoPagtoService";

export default {
    components: {
        AlertContainer,
        Loader,
        ContainerLoader,
        Message
    },
    data() {
        return {
            service: new RegrasDescontoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            tabPrecoService: new TabPrecoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            formaPgtoService: new FormaPagtoService(this.$http, this.$router),
            prazoPgtoService: new PrazoPagtoService(this.$http, this.$router),
            validation: new RegraDescontoValidation(this.msgs),
            venPoliticaDesconto: {
                descricao: "",
                situacao: { id: 1, label: "ativo" },
                tipoRegraProduto: { id: 0, label: 'por-produto' },
                formaAplicarRegra:{},
                tabelaPreco: null,
                assEmpresaVenPoliticaDescontoList: [],
                assUsuarioVenPoliticaDescontoList: [],
                assClienteVenPoliticaDescontoList: [],
                assFormaPagtoVenPoliticaDescontoList: [],
                assPrazoPagtoVenPoliticaDescontoList: [],
            },
            situacaoSelect: [
                { id: 0, label: "inativo" },
                { id: 1, label: "ativo" },
            ],
            tipoOperacaoUsadaSelect: [
                { id: 0, label: 'valor-total-pedido' },
                { id: 1, label: 'quantidade-total-pedido' },
                { id: 2, label: 'valor-total-itens' },
                { id: 3, label: 'quantidade-total-itens' },
                { id: 4, label: 'por-item' },
            ],
            tipoRegraProdutoSelect: [
                { id: 0, label: 'por-produto' },
                { id: 1, label: 'por-grupo' },
                { id: 2, label: 'por-produto-grupo' },
            ],
            formaAplicarRegraSelect: [
                {id: 0, label: 'percentual'},
                {id: 1, label: 'valor-monetario'}
            ],
            isUpdate: false,
            empresaSelect: [],
            tabPrecoSelect: [],
            colaboradorSelect: [],
            prazosPgtoSelect: [],
            formaPgtoSelect: [],
            clienteSelect: [],
            prazoPgtoSelect: [],
            regraDescontoLoading: false,
            empresasLoading: false,
            tabPrecoLoading: false,
            colaboradorLoading: false,
            clienteLoading: false,
            formaPgtoLoading: false,
            prazoPgtoLoading: false,
            msgs: [],
            isSaving: false,
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
            this.carregarRegraDesconto();
        }

        this.carregarEmpresas('');
        this.carregarTabPreco('');
        this.carregarColaborador('');
        this.carregarCliente('');
        this.carregarFormaPgto('');
        this.carregarPrazoPgto('');
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-regra-desconto-' + numberId;
        },
        carregarRegraDesconto(){
            this.regraDescontoLoading = true;
            this.service
                .find(this.$route.params.id)
                .then(r => {
                    if (r.status == 200) {
                        this.mapRegraDescontoEdit(r.content)
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar regra de desconto.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar regra de desconto.', e);
                })
                .finally(_ => {
                    this.regraDescontoLoading = false;
                });
        },
        save() {
            const politicaDesconto = this.mapOnSave();
            let msg = null;
            if (this.validation.validate(politicaDesconto, this.$refs, msg)) {
                this.service
                    .save(politicaDesconto)
                    .then((value) => {
                        if (value.status == 200) {
                            this.msgs.push(new Message("success", "msg-save-politica-desconto", true));
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message("alert", e.message, true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                if(msg){
                    this.$root.msgs.push(new Message("alert", msg, true));
                } else {
                    this.$root.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                }
                this.isLoading = false;
            }
        },
        mapRegraDescontoEdit(obj){
            this.venPoliticaDesconto.descricao = obj.descricao;
            this.venPoliticaDesconto.codigo = obj.idVenPoliticaDescontoErp;
            this.venPoliticaDesconto.situacao = this.situacaoSelect[obj.situacao];
            this.venPoliticaDesconto.dataInicial = new Date(obj.dataInicial);
            this.venPoliticaDesconto.dataFinal = new Date(obj.dataFinal);
            this.venPoliticaDesconto.tabelaPreco = {id: obj.tabelaPreco.idtabpreco, label: obj.tabelaPreco.descricao}
            this.venPoliticaDesconto.tipoOperacaoUsada = this.tipoOperacaoUsadaSelect[obj.tipoOperacaoUsada];
            this.venPoliticaDesconto.formaAplicarRegra = this.formaAplicarRegraSelect[obj.regraCampoValor];

            this.venPoliticaDesconto.assEmpresaVenPoliticaDescontoList =
            obj.assEmpresaVenPoliticaDescontoList.map(item => {
                return {id: item.idEmpresa, label: item.nomeEmpresa}
            });

            this.venPoliticaDesconto.assUsuarioVenPoliticaDescontoList =
            obj.assUsuarioVenPoliticaDescontoList.map(item => {
                return {id: item.idUsuario, label: item.nomeUsuario}
            });

            this.venPoliticaDesconto.assClienteVenPoliticaDescontoList =
            obj.assClienteVenPoliticaDescontoList.map(item => {
                return {id: item.idCliente, label: item.nomeCliente}
            });

            this.venPoliticaDesconto.assFormaPagtoVenPoliticaDescontoList =
            obj.assFormaPagtoVenPoliticaDescontoList.map(item => {
                return {id: item.idFormaPagto, label: item.descricaoFormaPagto}
            });

            this.venPoliticaDesconto.assPrazoPagtoVenPoliticaDescontoList =
            obj.assPrazoPagtoVenPoliticaDescontoList.map(item => {
                return {id: item.idPrazoPagto, label: item.descricaoPrazoPagto}
            });
        },
        mapOnSave(){
            let venPoliticaDescontoNovo = JSON.parse(JSON.stringify(this.venPoliticaDesconto)); //Remover referencia da memória
            venPoliticaDescontoNovo.idVenPoliticaDescontoErp  = this.venPoliticaDesconto.codigo;
            venPoliticaDescontoNovo.idVenPoliticaDesconto  = this.$route.params.id;
            venPoliticaDescontoNovo.tipoOperacaoUsada = this.venPoliticaDesconto.tipoOperacaoUsada ? this.venPoliticaDesconto.tipoOperacaoUsada.id : null
            venPoliticaDescontoNovo.tipoRegraProduto = this.venPoliticaDesconto.tipoRegraProduto ? this.venPoliticaDesconto.tipoRegraProduto.id : null
            venPoliticaDescontoNovo.idTabpreco = this.venPoliticaDesconto.tabelaPreco ? this.venPoliticaDesconto.tabelaPreco.id : null
            venPoliticaDescontoNovo.tabelaPreco = {idtabpreco: this.venPoliticaDesconto.tabelaPreco ? this.venPoliticaDesconto.tabelaPreco.id : null}
            venPoliticaDescontoNovo.situacao = this.venPoliticaDesconto.situacao && this.venPoliticaDesconto.situacao.id ? this.venPoliticaDesconto.situacao.id : this.situacaoSelect[1].id
            venPoliticaDescontoNovo.regraCampoValor = this.venPoliticaDesconto.formaAplicarRegra ? this.venPoliticaDesconto.formaAplicarRegra.id : null

            venPoliticaDescontoNovo.assEmpresaVenPoliticaDescontoList =
            this.venPoliticaDesconto.assEmpresaVenPoliticaDescontoList ?
            this.venPoliticaDesconto.assEmpresaVenPoliticaDescontoList.map(item => {
                return{
                    idEmpresa: item.id,
                    idVenPoliticaDesconto: this.$route.params.id
                }
            })
            : [];

            venPoliticaDescontoNovo.assUsuarioVenPoliticaDescontoList =
            this.venPoliticaDesconto.assUsuarioVenPoliticaDescontoList ?
            this.venPoliticaDesconto.assUsuarioVenPoliticaDescontoList.map(item => {
                    return{
                        idUsuario: item.id,
                        idVenPoliticaDesconto: this.$route.params.id
                    }
                })
            : [];

            venPoliticaDescontoNovo.assClienteVenPoliticaDescontoList =
            this.venPoliticaDesconto.assClienteVenPoliticaDescontoList ?
            this.venPoliticaDesconto.assClienteVenPoliticaDescontoList.map(item => {
                    return{
                        idCliente: item.id,
                        idVenPoliticaDesconto: this.$route.params.id
                    }
                })
            : [];

            venPoliticaDescontoNovo.assFormaPagtoVenPoliticaDescontoList =
            this.venPoliticaDesconto.assFormaPagtoVenPoliticaDescontoList ?
            this.venPoliticaDesconto.assFormaPagtoVenPoliticaDescontoList.map(item => {
                return{
                    idFormaPagto: item.id,
                    idVenPoliticaDesconto: this.$route.params.id
                }
            })
            : [];

            venPoliticaDescontoNovo.assPrazoPagtoVenPoliticaDescontoList =
            this.venPoliticaDesconto.assPrazoPagtoVenPoliticaDescontoList ?
            this.venPoliticaDesconto.assPrazoPagtoVenPoliticaDescontoList.map(item => {
                return{
                    idPrazoPagto: item.id,
                    idVenPoliticaDesconto: this.$route.params.id
                }
            })
            : [];

            return venPoliticaDescontoNovo;
        },
        carregarEmpresas(q = '') {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then(r => {
                    if (r.status == 200) {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar empresas.', e);
                })
                .finally(_ => {
                    this.empresasLoading = false;
                });
        },
        carregarTabPreco(q = '') {
            this.tabPrecoLoading = true;
            this.tabPrecoService
                .findAll("datahorainc", "desc", 0, 20, q)
                .then(r => {
                    if (r.status == 200) {
                        this.tabPrecoSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                label: e.descricao,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar tabela de preço.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar tabela de preço.', e);
                })
                .finally(_ => {
                    this.tabPrecoLoading = false;
                });
        },
        carregarColaborador(q = '') {
            this.colaboradorLoading = true;
            this.colaboradorService
                .findListAssociated(q)
                .then(r => {
                    if (r.status == 200) {
                        this.colaboradorSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                label: e.nome,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar colaborador.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar colaborador.', e);
                })
                .finally(_ => {
                    this.colaboradorLoading = false;
                });
        },
        carregarPrazoPgto(q) {
            this.prazoPgtoLoading = true;
            this.prazoPgtoService
                .findAllCombo(q)
                .then(r => {
                    if (r.status == 200) {
                        this.prazoPgtoSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                label: e.descricao,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar prazopagto.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar prazopagto.', e);
                })
                .finally(_ => {
                    this.prazoPgtoLoading = false;
                });
        },
        carregarFormaPgto(q) {
            this.formaPgtoLoading = true;
            this.formaPgtoService
                .findAllCombo(q)
                .then(r => {
                    if (r.status == 200) {
                        this.formaPgtoSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                label: e.descricao,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar formapgto.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar formapgto.', e);
                })
                .finally(_ => {
                    this.formaPgtoLoading = false;
                });
        },
        carregarCliente(q) {
            this.clienteLoading = true;
            this.clienteService
                .listAll(20, q)
                .then(r => {
                    if (r.status == 200) {
                        this.clienteSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                label: e.nome,
                            };
                        });
                    } else {
                        console.error(`[REGRA DE DESCONTO] Erro status ${r.status} ao carregar clientes.`);
                        console.error(`[REGRA DE DESCONTO] Mensagem: ${r.message}`);
                    }
                })
                .catch(e => {
                    console.error('[REGRA DE DESCONTO] Erro ao carregar clientes.', e);
                })
                .finally(_ => {
                    this.clienteLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.venPoliticaDesconto.assEmpresaVenPoliticaDescontoList = empresa;
        },
        updateTabPreco(tabPreco) {
            this.venPoliticaDesconto.tabelaPreco = tabPreco;
        },
        updateColaborador(colaborador) {
            this.venPoliticaDesconto.assUsuarioVenPoliticaDescontoList = colaborador;
        },
        updatePrazoPgto(prazoPgto) {
            this.venPoliticaDesconto.assPrazoPagtoVenPoliticaDescontoList = prazoPgto;
        },
        updateFormaPgto(formaPgto) {
            this.venPoliticaDesconto.assFormaPagtoVenPoliticaDescontoList = formaPgto;
        },
        updateCliente(cliente) {
            this.venPoliticaDesconto.assClienteVenPoliticaDescontoList = cliente;
        },
        updateTipoOperacaoUsada(tipoOperacaoUsada) {
            this.venPoliticaDesconto.tipoOperacaoUsada = tipoOperacaoUsada;
        },
        updateFormaAplicarRegra(formaAplicarRegra) {
            this.venPoliticaDesconto.formaAplicarRegra = formaAplicarRegra;
        },
    }
};
</script>

<style lang="scss" scoped>
@import "./mixins.scss";

.column {
    @include default-size-column;
}

#main {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    height: auto;
    min-height: 100%;

    .page {
        position: relative;

        .turno-header {
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            .column {
                padding: 0.25rem 0.75rem;
            }
        }
    }

    .excluir-field .svg-loader {
        margin-left: 0;
    }

    .btn {
        min-height: 30px;
    }

    .periodos-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 1.25rem;
        padding-right: 1.25rem;
        padding-bottom: 0.75rem;
        padding-left: 0.75rem;

        h1.title.mid {
            padding-bottom: 0;
            margin-right: 0;
        }

        button {
            padding: 10px;
        }
    }

    .modal-es {
        border-radius: 3px;

        .content {
            margin-top: 0px;
        }

        .horarios {
            min-height: 140px;

            .label-tipo {
                align-items: center;
                color: $dark-gray-color;
                font-weight: 600;

                span {
                    margin-top: 1.25rem;
                }
            }
        }

        .add-es {
            justify-content: center;
        }

        .with-del-btn {
            .exclude-btn {
                margin-top: 1.5rem;
                margin-left: 1rem;
            }

            .hour {
                width: 100%;
            }
        }

        button.save-btn,
        button.delete-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 45px;
            padding: 0 15px;
        }
    }
}
</style>